<script setup>
  import { defineProps, ref, computed  } from "vue";
  import { _CSP_ORDER_STATUS_MAP } from '@/const/shopifyConst.js';
  const props = defineProps({
    orderStatus: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    }
  });
  // eslint-disable-next-line
  const orderStatus = ref(props.orderStatus);
  // eslint-disable-next-line
  const orderLabel = computed(() => props.label);
</script>

<template>
    <div :class="['csr-account__order-status', _CSP_ORDER_STATUS_MAP[orderStatus]?.className]">{{ orderLabel }}</div>
</template>